import { Controller } from "@hotwired/stimulus";
import { CustomFavStoresRemovalEvent } from "@hotwired/turbo";

export default class extends Controller {
  connect(): void {
    const favStoreTurboFrame = document.getElementById('favourite-stores')
    const storesSize = document.getElementById('fav-stores-size');
    const storeNames = document.getElementById('fav-stores-names');
    
    favStoreTurboFrame?.addEventListener('turbo:before-frame-render', (e) => {
      const event = e as CustomFavStoresRemovalEvent;
      const element = event.detail.newFrame;
      const newSize = (element.dataset.storeCount) as string;
      const newNames = (element.dataset.storeNames) as string;

      if (storesSize && newSize) { storesSize.innerHTML = newSize };
      if (storeNames && newNames) { storeNames.innerHTML = newNames };
  
      if (newSize == "0") {
        const storeNameCardToHide = document.getElementById('store-name-card-to-hide');
        storeNameCardToHide?.classList.add('is-completely-hidden');
      }
    })
  }
}
